import { LinkButton } from '@cluey/cluey-components';

import SchoolHolidaySessionImage from '../../../assets/images/school-holiday-session.png';
import HubPageLayout from '../../../common/hub/HubPageLayout';
import { PageTitle } from '../../../components/hub/PageTitle';
import { TicketIcon } from '../../../icons/TicketIcon';
import { PATH_HUB_HOME, PATH_HUB_UPCOMING_SESSIONS } from '../../../util/pagePath';

const HowToUseVouchers = () => {
  return (
    <HubPageLayout>
      <>
        <PageTitle title="Cluey Vouchers" className="pb-6" breadcrumbs={[{ label: 'Home', to: PATH_HUB_HOME }]} />
        <div className="flex flex-col gap-y-6">
          <div className="flex flex-col gap-4 rounded-lg bg-slate-1 p-6 lg:flex-row">
            <div className="flex flex-row gap-3 lg:flex-row">
              <div className="flex !w-6 items-start justify-center">
                <TicketIcon width={24} height={24} className="mt-[2px] fill-blood-orange-4" />
              </div>
              <div className="flex flex-col items-start gap-2">
                <div className="flex items-center gap-3 text-lg font-bold lg:gap-4">
                  <p className="text-xl font-bold">How Cluey Vouchers work</p>
                </div>
                <div className="flex flex-col gap-3">
                  <p>
                    Cluey Vouchers are issued when a <u>paid school holiday session</u> is cancelled. Each voucher can
                    be used to book a make-up session and is valid for 75 days from the original session date.
                  </p>
                  <p>You can use your vouchers for any active enrolment on your account.</p>
                  <div className="my-4">
                    <figure className="flex flex-col items-center justify-center space-y-2">
                      <img src={SchoolHolidaySessionImage} alt="School holiday session" />
                      <figcaption>Look for the School Holiday Session tag</figcaption>
                    </figure>
                  </div>
                </div>
                <div className="flex w-full flex-col items-center justify-center">
                  <LinkButton to={PATH_HUB_UPCOMING_SESSIONS}>Click here to view your upcoming sessions</LinkButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </HubPageLayout>
  );
};

export default HowToUseVouchers;
